import React, { useState, useEffect, useRef, Fragment } from "react";
import * as _ from "lodash";
import "../AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead, WaterMarkName } from "../ShareFunctionsPrint";
import HeaderEn from "./A4/HeaderEn";
import BodyEn from "./A4/BodyEn";
import InvTotalsEn from "./A4/InvTotalsEn";
import { ButtonBase, Grid } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";

function HeadersNew(props) {
    const { locInv, found, sta, inv } = props;
    return (
        <div style={stylePaddingHead}>
            < HeaderEn locInv={locInv} info={found} sta={sta} inv={inv} />
        </div>
    );
}
function BodyInvoice(props) {
    const { chunk } = props;
    return (
        <div style={stylePadding}>
            <BodyEn data={chunk ?? []} />
        </div>
    );
}

function Footers(props) {
    const { found } = props;
    const clas = useInvAF();
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <Grid xs={12} item style={{ maxHeight: "3.8cm", minHeight: "3.8cm" }}>
                {found.footer_img != null ? (
                    (
                        <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                            <div>
                                <ButtonBase>
                                    {" "}
                                    <img
                                        src={`data:image/jpeg;base64,${found.footer_img}`}
                                        className={clas.headerImg}
                                        alt={found.nameA}
                                    />{" "}
                                </ButtonBase>
                            </div>
                        </Grid>
                    )
                ) : null}
            </Grid>
        </div>
    );
}

function EnglishInvPrint(props) {
    const { locInv, found, sta, inv, data } = props;
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const totalsRef = useRef(null);
    const rowRefs = useRef([]);
    const [pages, setPages] = useState([]);

    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const totalsH = totalsRef.current?.offsetHeight || 0;
            const max_Height = PAGE_HEIGHT - (HEADER1 + FOOTER1 + 20);
            const heights = rowRefs.current.map(el => el?.offsetHeight || 0);

            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            data.forEach((item, i) => {
                const rowHieght = heights[i];
                if (currentHeight + rowHieght > max_Height) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + totalsH > max_Height) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [data]);
    return (
        <>
            <div className="measurecon" >
                <div ref={headerRef}>
                    <HeadersNew locInv={locInv} sta={sta ?? {}} found={found} inv={inv} />
                </div>
                {data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowRefs.current[i] = el)}
                        className="measurerow2"
                    >
                        { item.notesall}
                    </div>
                ))}
                
                <div ref={totalsRef}>
                    <InvTotalsEn locInv={locInv} inv={inv} sta={sta ?? {}} />
                </div>
                <div ref={footerRef}>
                    <Footers found={found} />
                </div>
            </div>
            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <WaterMarkName found={found} />
                        <div className="contentview">
                            <HeadersNew locInv={locInv} sta={sta ?? {}} found={found} inv={inv} />
                            <BodyInvoice chunk={page ?? []} />
                            {i == pages.length - 1 &&
                            <InvTotalsEn locInv={locInv} inv={inv} sta={sta ?? {}} />}
                        </div>
                        <Footers found={found} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default EnglishInvPrint;
